import LegalLayout from "./LegalLayout";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";

export default function AGB() {
  return (
    <>
      <Navigation />
      <LegalLayout
        title="Allgemeine Geschäftsbedingungen"
        subtitle="AGB für Behandlungs- und Friseurleistungen"
        testid="agb-page"
      >
        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 1 Geltungsbereich
          </h2>
          <p>
            (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle
            Verträge über Dienstleistungen zwischen Hair &amp; Beauty Nava
            (Betreiberinnen: H. Dogan &amp; N. Noury), Hainer Weg 146, 60599 Frankfurt
            am Main (nachfolgend „Studio") und unseren Kund:innen.
          </p>
          <p className="mt-3">
            (2) Abweichende Bedingungen werden nur Vertragsbestandteil, wenn
            das Studio diesen ausdrücklich schriftlich zustimmt.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 2 Vertragsschluss &amp; Terminbuchung
          </h2>
          <p>
            (1) Termine für Beauty-Behandlungen können online über unseren
            Buchungspartner Salonkee oder telefonisch unter +49 1575 9436804
            vereinbart werden.
          </p>
          <p className="mt-3">
            (2) Termine im Bereich Friseur werden ausschließlich telefonisch
            unter +49 177 1815027 vergeben.
          </p>
          <p className="mt-3">
            (3) Der Vertrag kommt mit Bestätigung des Termins durch das Studio
            zustande.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 3 Leistungen &amp; Preise
          </h2>
          <p>
            (1) Es gelten die zum Zeitpunkt der Buchung auf der Website oder
            telefonisch vereinbarten Preise. Alle Preise verstehen sich als
            Endpreise inkl. der gesetzlichen Mehrwertsteuer (sofern
            ausweisungspflichtig).
          </p>
          <p className="mt-3">
            (2) Bei Friseurleistungen können sich die endgültigen Kosten je
            nach Haarlänge, Dichte und Aufwand erhöhen. Etwaige Aufpreise werden
            vor Beginn der Behandlung kommuniziert.
          </p>
          <p className="mt-3">
            (3) Bei kosmetischen Behandlungen (z. B. Peeling,
            Microdermabrasion) wird vor der Behandlung eine fachliche
            Aufklärung durchgeführt. Die Behandlung erfolgt erst nach
            Einwilligung der Kundin / des Kunden.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 4 Stornierung &amp; Nichterscheinen
          </h2>
          <p>
            (1) Termine können bis <strong className="text-white">24 Stunden</strong>{" "}
            vor dem vereinbarten Zeitpunkt kostenfrei storniert oder verschoben
            werden.
          </p>
          <p className="mt-3">
            (2) Bei kurzfristigen Absagen unter 24 Stunden oder Nichterscheinen
            („No-Show") behalten wir uns vor, eine Ausfallpauschale in Höhe
            von 50 % des Behandlungspreises in Rechnung zu stellen.
          </p>
          <p className="mt-3">
            (3) Eine Stornierung kann telefonisch oder per E-Mail an{" "}
            <a href="mailto:hairbeautynava@gmail.com" className="text-white hover:text-[#D4AF37]">
              hairbeautynava@gmail.com
            </a>{" "}
            erfolgen.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 5 Zahlung
          </h2>
          <p>
            Die Zahlung erfolgt unmittelbar nach der Behandlung im Studio. Es
            werden folgende Zahlungsmittel akzeptiert: Barzahlung sowie nach
            Verfügbarkeit EC- bzw. Kartenzahlung.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 6 Mitwirkungspflicht der Kund:innen
          </h2>
          <p>
            Kund:innen sind verpflichtet, vor Behandlungsbeginn auf
            gesundheitliche Besonderheiten, Allergien, Unverträglichkeiten,
            Schwangerschaft, Medikamenteneinnahme oder Hautkrankheiten
            hinzuweisen. Bei Unterlassen übernimmt das Studio keine Haftung für
            daraus resultierende Folgen.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 7 Gewährleistung &amp; Haftung
          </h2>
          <p>
            (1) Es gelten die gesetzlichen Gewährleistungsrechte.
          </p>
          <p className="mt-3">
            (2) Das Studio haftet unbeschränkt für Vorsatz und grobe
            Fahrlässigkeit sowie nach dem Produkthaftungsgesetz. Für leichte
            Fahrlässigkeit haftet das Studio nur bei Verletzung von Leben,
            Körper oder Gesundheit oder wesentlichen Vertragspflichten
            (Kardinalpflichten).
          </p>
          <p className="mt-3">
            (3) Bei Verletzung wesentlicher Vertragspflichten ist die Haftung
            auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 8 Gutscheine
          </h2>
          <p>
            Verkaufte Gutscheine sind drei Jahre ab Ausstellung gültig, sofern
            nicht ausdrücklich anders vermerkt. Eine Barauszahlung ist
            ausgeschlossen.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 9 Datenschutz
          </h2>
          <p>
            Die Verarbeitung personenbezogener Daten richtet sich nach unserer{" "}
            <a href="/datenschutz" className="text-white hover:text-[#D4AF37] underline">
              Datenschutzerklärung
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            § 10 Schlussbestimmungen
          </h2>
          <p>
            (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss
            des UN-Kaufrechts.
          </p>
          <p className="mt-3">
            (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder
            werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
          <p className="mt-3">
            (3) Erfüllungsort und – soweit gesetzlich zulässig – Gerichtsstand
            ist Frankfurt am Main.
          </p>
        </section>

        <p className="text-white/40 text-xs pt-8 border-t border-white/10">
          Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
        </p>
      </LegalLayout>
      <Footer />
    </>
  );
}
